{
  "name": "@llamaindex/workflows-client",
  "version": "1.8.1",
  "description": "TypeScript client for LlamaIndex Workflows server",
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "files": [
    "dist",
    "README.md"
  ],
  "scripts": {
    "generate": "pnpx @hey-api/openapi-ts",
    "build": "tsup",
    "dev": "tsup --watch",
    "typecheck": "tsc --noEmit",
    "clean": "rm -rf dist src/generated",
    "prepublishOnly": "pnpm run build"
  },
  "keywords": [
    "llamaindex",
    "workflows",
    "api",
    "client",
    "typescript"
  ],
  "author": "LlamaIndex",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "https://github.com/run-llama/workflows-py"
  },
  "devDependencies": {
    "@hey-api/openapi-ts": "^0.82.4",
    "@types/node": "^20.0.0",
    "tsup": "^8.0.0",
    "typescript": "^5.3.0"
  },
  "engines": {
    "node": ">=18.0.0"
  },
  "packageManager": "pnpm@10.11.1+sha512.e519b9f7639869dc8d5c3c5dfef73b3f091094b0a006d7317353c72b124e80e1afd429732e28705ad6bfa1ee879c1fce46c128ccebd3192101f43dd67c667912"
}
